var _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSustainabilityPageShape1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 455.81,
    height: 306.58
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "SustainabilityPageShape1_svg__SustainabilityPageShape1Mask",
    clipPathUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.051.035a.895 1 0 01.937.536.066.098 0 01-.021.141L.65.987A.066.099 0 01.565.962.398.591 0 00.189.747.066.099 0 01.115.68L.003.16A.066.098 0 01.051.035"
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZwoJeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgoJd2lkdGg9IjQ1NS44MSIKCWhlaWdodD0iMzA2LjU4IgoJdmlld0JveD0iMCAwIDQ1NS44MSAzMDYuNTgiCj4KCTxkZWZzPgoJCTxjbGlwUGF0aAoJCQlpZD0iU3VzdGFpbmFiaWxpdHlQYWdlU2hhcGUxTWFzayIKCQkJY2xpcFBhdGhVbml0cz0ib2JqZWN0Qm91bmRpbmdCb3giCgkJPgoJCQk8cGF0aAoJCQkJZD0iTTAuMDUxLDAuMDM1IEEwLjg5NSwxLDAsMCwxLDAuOTg4LDAuNTcxIGEwLjA2NiwwLjA5OCwwLDAsMSwtMC4wMjEsMC4xNDEgTDAuNjUsMC45ODcgQTAuMDY2LDAuMDk5LDAsMCwxLDAuNTY1LDAuOTYyIEEwLjM5OCwwLjU5MSwwLDAsMCwwLjE4OSwwLjc0NyBhMC4wNjYsMC4wOTksMCwwLDEsLTAuMDc0LC0wLjA2NyBMMC4wMDMsMC4xNiBBMC4wNjYsMC4wOTgsMCwwLDEsMC4wNTEsMC4wMzUiCgkJCS8+CgkJPC9jbGlwUGF0aD4KCTwvZGVmcz4KPC9zdmc+Cg==";
export { SvgSustainabilityPageShape1 as ReactComponent };